module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-vehicle-category"
  }, [_c('modal-reveal', {
    ref: "modalEditVehicleCategory",
    attrs: {
      "sizing": "small"
    }
  }, [_c('a', {
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Edit")]), _c('h2', [_vm._v("Edit Vehicle Category " + _vm._s(_vm.item.id) + " - " + _vm._s(_vm.item.name))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.name),
      expression: "item.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "name", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Description"), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.description),
      expression: "item.description"
    }],
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.item.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "description", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Category damage picture")]), _c('KeplerFileUpload', {
    attrs: {
      "selected-prefix": "damage-picture",
      "selected-visibility": "public",
      "previewUrl": _vm.item.damage_picture
    },
    on: {
      "sel": _vm.handleFileDamageSelector
    }
  })], 1), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Vehicle Types"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.vehicle_type.id),
      expression: "item.vehicle_type.id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.item.vehicle_type, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vehicleTypes), function(vehicleType) {
    return _c('option', {
      domProps: {
        "value": vehicleType.id
      }
    }, [_vm._v(_vm._s(vehicleType.name))])
  }), 0)]), _c('label', [_vm._v("Category image")]), _c('KeplerFileUpload', {
    attrs: {
      "selected-prefix": "vehicle-categories",
      "selected-visibility": "public",
      "previewUrl": _vm.item.picture
    },
    on: {
      "sel": _vm.handleFileSelector
    }
  })], 1)]), _c('div', {
    staticClass: "row column"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.editVehicleCategory
    }
  }, [_vm._v("Edit")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e1a40aa6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/asset-management/EditVehicleCategory.vue
// module id = 2716
// module chunks = 1